import React, { useState, useEffect, useRef } from 'react';
import { Form } from 'react-bootstrap';
import Panel from 'components/common/panel/panel';
import Inputs from 'components/inputs/inputs';
import Popup from 'components/common/popup/popup';
import { Tabs, Tab } from 'components/common/tabs/tabs';
import SiteNode from 'components/shared/siteSelector/siteNode';
import Helpers from 'utils/helpers';
import moment from 'moment';
import _ from 'lodash';
import './lighthouseEnterpriseDemoPage.css';

import Chartjs from 'chart.js';
import { InitLineChartOptions } from 'components/common/glances/baseGlances/initChartOptions';
import TestColumns from './data/columns';
import TestDataStore1 from './data/data1';
import TestDataStore2 from './data/data2';
import TestDataStore3 from './data/data3';
import TestDataStore4 from './data/data4';
import TestDataStore5 from './data/data5';
import TestHierarchy from './data/hierarchy';

export default function LighthouseEnterpriseDemoPage(props) {
  const [showSiteSelectorModal, setShowSiteSelectorModal] = useState(false);
  const [showChartConfigModal, setShowChartConfigModal] = useState(false);
  const [showTableConfigModal, setShowTableConfigModal] = useState(false);
  const [dates, setDates] = useState(['Fri 10/16/20', 'Sat 10/17/20', 'Sun 10/18/20', 'Mon 10/19/20', 'Tue 10/20/20', 'Wed 10/21/20', 'Thu 10/22/20']);
  const [datesId, setDatesId] = useState(1);
  const [chartGroup, setChartGroup] = useState('store');

  const setDatesLast7 = () => {
    setDates(['Fri 10/16/20', 'Sat 10/17/20', 'Sun 10/18/20', 'Mon 10/19/20', 'Tue 10/20/20', 'Wed 10/21/20', 'Thu 10/22/20']);
    setDatesId(1);
  };

  const setDatesMondays = () => {
    setDates(['Mon 9/7/20', 'Mon 9/14/20', 'Mon 9/21/20', 'Mon 9/28/20', 'Mon 10/5/20', 'Mon 10/12/20', 'Mon 10/19/20']);
    setDatesId(11);
  };

  return (
    <div className='lighthouse-demo'>
      <Panel>
        <Panel.Header>Enterprise Hierarchy</Panel.Header>
        <Panel.Body>
          <HierarchyTree isReadOnly={true} />
        </Panel.Body>
      </Panel>
      <Panel>
        <Panel.Header>Define Store Groups</Panel.Header>
        <Panel.Body>
          <StoreGroupSetup setShowSiteSelector={setShowSiteSelectorModal} />
        </Panel.Body>
      </Panel>
      <Panel>
        <Panel.Header>Report Setup</Panel.Header>
        <Panel.Body>
          <h4>Report</h4>
          <div className='my-3 px-3'>
            <Form.Control as='select'>
              <option>Sales Statistics Report</option>
              <option>Time Report</option>
              <option>Labor Report</option>
              <option>Transaction Report</option>
            </Form.Control>
          </div>
          <h4>Dates</h4>
          <div className='my-3 px-3'>
            <Tabs defaultSelection={datesId > 10 ? 'daysofweek' : 'recentdays'}>
              <Tab value='recentdays' title='Recent (Daily)'>
                <Inputs.Button variant={datesId === 1 ? 'lh' : 'lh-outline'} size='xs' label='Last 7 Days' className='mr-2' onClick={setDatesLast7} />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 14 Days' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 21 Days' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 28 Days' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 30 Days' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Custom Days' className='mr-2' />
              </Tab>
              <Tab value='daysofweek' title='Days of the Week (Daily)'>
                <Inputs.Button variant={datesId === 11 ? 'lh' : 'lh-outline'} size='xs' label='Last 7 Mondays' className='mr-2' onClick={setDatesMondays} />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 7 Tuesdays' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 7 Wednesdays' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 7 Thursdays' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 7 Fridays' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 7 Saturdays' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 7 Sundays' className='mr-2' />
              </Tab>
              <Tab value='recentweeks' title='Recent (Weekly)'>
                <Inputs.Button variant='lh-outline' size='xs' label='Last 4 Weeks' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 8 Weeks' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 12 Weeks' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 16 Weeks' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Custom Weeks' className='mr-2' />
              </Tab>
              <Tab value='recentmonths' title='Recent (Monthly)'>
                <Inputs.Button variant='lh-outline' size='xs' label='Last 3 Months' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 6 Months' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 9 Months' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Last 12 Months' className='mr-2' />
                <Inputs.Button variant='lh-outline' size='xs' label='Custom Months' className='mr-2' />
              </Tab>
            </Tabs>
          </div>
          <h4>Store Groups</h4>
          <div className='my-3 px-3'>
            <Inputs.Button variant='lh-outline' size='xs' label='Select Store Groups' className='mb-2' />
            <div className='my-1'>
              <span className='text-thick'>Texas</span>
              <div className='badge badge-sm badge-pill badge-info ml-2'>2</div>
              <div className='badge badge-sm badge-light-info ml-2'>States</div>
            </div>
            <div className='my-1'>
              <span className='text-thick'>Florida</span>
              <div className='badge badge-sm badge-pill badge-info ml-2'>2</div>
              <div className='badge badge-sm badge-light-info ml-2'>States</div>
            </div>
            <div className='my-1'>
              <span className='text-thick'>California</span>
              <div className='badge badge-sm badge-pill badge-info ml-2'>1</div>
              <div className='badge badge-sm badge-light-info ml-2'>States</div>
            </div>
          </div>
        </Panel.Body>
      </Panel>
      <div className='row'>
        <div className='col-12'>
          <Panel>
            <Panel.Header tools={<Inputs.Button variant='hover-default' iconClass='icons8-settings' onClick={() => setShowChartConfigModal(true)} />}>
              Sales Statistics - Trend Analysis
            </Panel.Header>
            <Panel.Body>
              <ChartComponent dates={dates} column={TestColumns[9]} group={chartGroup} />
              <ChartConfigModal column={TestColumns[9]} show={showChartConfigModal} setGroup={setChartGroup} onClose={() => setShowChartConfigModal(false)} />
            </Panel.Body>
          </Panel>
        </div>
        <div className='col-12'>
          <Panel>
            <Panel.Header tools={<Inputs.Button variant='hover-default' iconClass='icons8-settings' onClick={() => setShowTableConfigModal(true)} />}>
              Sales Statistics
            </Panel.Header>
            <Panel.Body>
              <TableComponent dates={dates} columns={TestColumns.filter((c, i) => ([1, 9, 8, 4, 5].includes(i)))} />
              <TableConfigModal included={[1, 9, 8, 4, 5]} show={showTableConfigModal} onClose={() => setShowTableConfigModal(false)} />
            </Panel.Body>
          </Panel>
        </div>
      </div>

      <HierarchyTreeModal show={showSiteSelectorModal} onClose={() => setShowSiteSelectorModal(false)} />
    </div>
  );
}

function ChartComponent(props) {
  const column = props.column;
  const dates = props.dates;
  const group = props.group;

  const chartContainer = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);

  useEffect(() => {
    if (chartContainer && chartContainer.current) {
      if (chartInstance && chartInstance.destroy) {
        chartInstance.destroy();
      }
      const newChartInstance = new Chartjs(chartContainer.current, getChartConfig());
      setChartInstance(newChartInstance);
    }
  }, [chartContainer, column, dates, group]);

  const getChartConfig = () => {
    const options = InitLineChartOptions(getChartOptions());
    const data = getChartData();
    return {
      type: 'line',
      data: data,
      options: options,
    };
  };

  const getChartOptions = () => {
    return {
      yAxis: column.name,
      xAxis: 'Date',
      legend: true,
      dollarFormat: column.dollarFormat,
    };
  };

  const getDatasetTemplate = (data, label, colorStr) => {
    return {
      'data': dates.map((d) => (data.filter((p) => (moment(p.BUSINESS_DATE).isSame(moment(d), 'day')))[0][column.key])),
      'label': label,
      'showLine': true,
      'spanGaps': false,
      'steppedLine': false,
      'fill': false,
      'lineTension': 0,
      'backgroundColor': `rgba(${colorStr},0.2)`,
      'borderColor': `rgba(${colorStr},0.6)`,
      'borderWidth': 2,
      'borderDashOffset': 0,
      'pointBackgroundColor': `rgba(${colorStr},1)`,
      'pointBorderColor': `rgba(${colorStr},1)`,
      'pointBorderWidth': 1,
      'pointRadius': 4,
      'pointHoverRadius': 6,
      'pointHitRadius': 12,
      'pointHoverBackgroundColor': `rgba(${colorStr},1)`,
      'pointHoverBorderColor': `rgba(${colorStr},1)`,
      'pointHoverBorderWidth': 2,
    };
  };

  const sumData = (values) => {
    let result = _.cloneDeep(values[0]);
    for (let i = 1; i < values.length; i++) {
      for (let j = 0; j < values[i].length; j++) {
        for (let c = 0; c < TestColumns.length; c++) {
          result[j][TestColumns[c].key] += values[i][j][TestColumns[c].key];
        }
      }
    }
    return result;
  };

  const getChartData = () => {
    let datasets = [];
    if (group === 'total') {
      datasets = [
        getDatasetTemplate(sumData([TestDataStore1, TestDataStore2, TestDataStore3, TestDataStore4, TestDataStore5]), 'Total', '0,0,0'),
      ];
    }
    else if (group === 'storegroup') {
      datasets = [
        getDatasetTemplate(sumData([TestDataStore1, TestDataStore2]), 'Texas', '78,129,180'),
        getDatasetTemplate(sumData([TestDataStore3, TestDataStore4]), 'Florida', '88,153,111'),
        getDatasetTemplate(TestDataStore5, 'California', '180,77,91'),
      ];
    }
    else {
      datasets = [
        getDatasetTemplate(TestDataStore1, 'Arlington, TX 0976', '102,168,150'),
        getDatasetTemplate(TestDataStore2, 'Houston, TX 0993', '150,77,88'),
        getDatasetTemplate(TestDataStore3, 'Jacksonville, FL 0600', '127,111,145'),
        getDatasetTemplate(TestDataStore4, 'Pensacola, FL 0668', '90,111,141'),
        getDatasetTemplate(TestDataStore5, 'Oxnard, CA 2699', '245,105,117'),
      ];
    }
    const data = {
      'labels': dates,
      'datasets': datasets,
    };
    return data;
  };

  return (
    <canvas ref={chartContainer} className='glance-chart chartjs-render-monitor' height='420' width='220' style={{ maxHeight: '420px' }}></canvas>
  );
}

function ChartConfigModal(props) {
  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    props.onClose();
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='lh-outline' size='sm' onClick={handleClose} label='Cancel' />
        <Inputs.Button variant='lh' size='sm' onClick={handleSubmit} label='Apply' />
      </>
    );
  };

  return (
    <Popup
      title='Configure Graph'
      footer={renderFooter()}
      show={props.show}
      onClose={handleClose}
      className='lighthouse-demo'
    >
      <Tabs defaultSelection='columns'>
        <Tab value='columns' title='Graph Metric'>
          <Inputs.RadioGroup defaultValue={props.column.key}>
            {TestColumns.map((column, index) => <Inputs.Radio value={column.key} label={column.name} variant='lh' block />)}
          </Inputs.RadioGroup>
        </Tab>
        <Tab value='grouping' title='Graph Grouping'>
          <Inputs.RadioGroup value='store' onChange={props.setGroup}>
            <Inputs.Radio value='store' label='Store' variant='lh' block />
            <Inputs.Radio value='storegroup' label='Store Group' variant='lh' block />
            <Inputs.Radio value='total' label='Total' variant='lh' block />
          </Inputs.RadioGroup>
        </Tab>
      </Tabs>
    </Popup>
  );
}

function TableComponent(props) {
  const columns = props.columns;
  const dates = props.dates;
  const [expand1, setExpand1] = useState(false);
  const [expand2, setExpand2] = useState(false);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const formatDollar = (x) => {
    return '$' + numberWithCommas(x.toFixed(2));
  };

  const renderHeaders = () => {
    return (
      <>
        <th>Metric</th>
        {columns.map((column, index) => {
          return (
            <th key={index}>{column.name}</th>
          );
        })}
      </>
    );
  };

  const renderDataGroupedByDate = (data, label, date) => {
    let rows = [];
    if (Helpers.Object.isArray(date)) {
      rows = data.filter((p) => date.map((d) => ((moment(p.BUSINESS_DATE).isSame(moment(d), 'day')))));
    }
    else {
      rows = data.filter((p) => (moment(p.BUSINESS_DATE).isSame(moment(date), 'day')));
    }
    return (
      <>
        <td>{label}</td>
        {columns.map((column, index) => {
          const values = rows.map((r) => (r[column.key]));
          const sum = (Helpers.Object.exists(values.length)) ? values.reduce((a, b) => a + b, 0) : values;
          return <td key={index}>{column.dollarFormat ? formatDollar(sum) : sum.toFixed(0)}</td>;
        })}
      </>
    );
  };

  const renderRows = () => {
    const TestDataAllStores = [...TestDataStore1, ...TestDataStore2, ...TestDataStore3, ...TestDataStore4, ...TestDataStore5];
    return (
      <>
        <tr>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[0]}</span></>, dates[0])}</tr>

        {expand1 ?
          <>
            <tr onClick={() => setExpand1(false)}>
              <td colspan='6'>
                <i className='icons8-sort-down' /> <span className='text-thick'>{dates[1]}</span>
              </td>
            </tr>
            <tr className='level-1'>{renderDataGroupedByDate([...TestDataStore1, ...TestDataStore2], <><i className='icons8-sort-right-2' /> <span>Texas</span></>, dates[1])}</tr>

            {expand2 ?
              <>
                <tr className='level-1' onClick={() => setExpand2(false)}>
                  <td colspan='6'>
                    <i className='icons8-sort-down' /> <span className='text-thick'>Florida</span>
                  </td>
                </tr>
                <tr className='level-2'>{renderDataGroupedByDate(TestDataStore3, <><i className='icons8-sort-right-2' /> <span>Jacksonville, FL 0600</span></>, dates[1])}</tr>
                <tr className='level-2'>{renderDataGroupedByDate(TestDataStore4, <><i className='icons8-sort-right-2' /> <span>Pensacola, FL 0668</span></>, dates[1])}</tr>
                <tr className='level-2 text-thick'>{renderDataGroupedByDate([...TestDataStore3, ...TestDataStore4], 'Total', dates[1])}</tr>
              </>
              :
              <tr className='level-1' onClick={() => setExpand2(true)}>{renderDataGroupedByDate([...TestDataStore3, ...TestDataStore4], <><i className='icons8-sort-right-2' /> <span>Florida</span></>, dates[1])}</tr>
            }

            <tr className='level-1'>{renderDataGroupedByDate(TestDataStore5, <><i className='icons8-sort-right-2' /> <span>California</span></>, dates[1])}</tr>
            <tr className='level-1 text-thick'>{renderDataGroupedByDate(TestDataAllStores, 'Total', dates[1])}</tr>
          </>
          :
          <tr onClick={() => setExpand1(true)}>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[1]}</span></>, dates[1])}</tr>
        }
        <tr>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[2]}</span></>, dates[2])}</tr>
        <tr>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[3]}</span></>, dates[3])}</tr>
        <tr>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[4]}</span></>, dates[4])}</tr>
        <tr>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[5]}</span></>, dates[5])}</tr>
        <tr>{renderDataGroupedByDate(TestDataAllStores, <><i className='icons8-sort-right-2' /> <span>{dates[6]}</span></>, dates[6])}</tr>
        <tr className='text-thick'>{renderDataGroupedByDate(TestDataAllStores, 'Total', dates)}</tr>
      </>
    )
  };

  return (
    <table className='table table-hover glance-table'>
      <thead>
        <tr>
          {renderHeaders()}
        </tr>
      </thead>
      <tbody>
        {renderRows()}
      </tbody>
    </table>
  );
}

function TableConfigModal(props) {
  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    props.onClose();
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='lh-outline' size='sm' onClick={handleClose} label='Cancel' />
        <Inputs.Button variant='lh' size='sm' onClick={handleSubmit} label='Apply' />
      </>
    );
  };

  return (
    <Popup
      title='Configure Table'
      footer={renderFooter()}
      show={props.show}
      onClose={handleClose}
      className='lighthouse-demo'
    >
      <Tabs defaultSelection='columns'>
        <Tab value='columns' title='Table Columns'>
          {TestColumns.map((column, index) => <Movable className='border-lh' disabled={!props.included.includes(index)}>{column.name}</Movable>)}
        </Tab>
        <Tab value='groups' title='Table Grouping'>
          <Movable className='border-lh'>Date</Movable>
          <Movable className='border-lh'>Store Group</Movable>
          <Movable className='border-lh'>Store</Movable>
          <Movable className='border-lh'>Revenue Center</Movable>
          <Movable className='border-lh' disabled={true}>Category</Movable>
        </Tab>
      </Tabs>
    </Popup>
  );
}

function StoreGroupSetup(props) {
  const handleAddSites = () => {
    props.setShowSiteSelector(true);
  };

  return (
    <div className='store-group-setup'>
      <div className='setup-panel'>
        <div className='title'>
          <span>Texas</span>
          <span className='badge badge-sm badge-light-info ml-2'>States</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Arlington, TX 0976</Movable>
        <Movable className='border-default' checkbox={false}>Houston, TX 0993</Movable>
      </div>
      <div className='setup-panel'>
        <div className='title'>
          <span>Florida</span>
          <span className='badge badge-sm badge-light-info ml-2'>States</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Jacksonville, FL 0600</Movable>
        <Movable className='border-default' checkbox={false}>Pensacola, FL 0668</Movable>
      </div>
      <div className='setup-panel'>
        <div className='title'>
          <span>California</span>
          <span className='badge badge-sm badge-light-info ml-2'>States</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Oxnard, CA 2699</Movable>
      </div>
      <div className='setup-panel'>
        <div className='title'>
          <span>East</span>
          <span className='badge badge-sm badge-light-success ml-2'>Region</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Jacksonville, FL 0600</Movable>
        <Movable className='border-default' checkbox={false}>Pensacola, FL 0668</Movable>
      </div>
      <div className='setup-panel'>
        <div className='title'>
          <span>West</span>
          <span className='badge badge-sm badge-light-success ml-2'>Region</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Oxnard, CA 2699</Movable>
        <Movable className='border-default' checkbox={false}>Arlington, TX 0976</Movable>
        <Movable className='border-default' checkbox={false}>Houston, TX 0993</Movable>
      </div>
      <div className='setup-panel'>
        <div className='title'>
          <span>Sells Liquor</span>
          <span className='badge badge-sm badge-light-danger ml-2'>Store Type</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Arlington, TX 0976</Movable>
      </div>
      <div className='setup-panel'>
        <div className='title'>
          <span>Has Extended Food Menu</span>
          <span className='badge badge-sm badge-light-danger ml-2'>Store Type</span>
          <i className='icons8-edit' />
        </div>
        <div className='add d-flex justify-content-between align-items-center'>
          <Inputs.Button className='mb-2' variant='lh-outline' size='sm' block iconClass='icons8-plus' label='Add' onClick={handleAddSites} />
        </div>
        <Movable className='border-default' checkbox={false}>Arlington, TX 0976</Movable>
        <Movable className='border-default' checkbox={false}>Houston, TX 0993</Movable>
      </div>
      <div className='setup-panel setup-panel-new'>
        <i className='icons8-plus text-lh' />
      </div>
    </div>
  );
}

function Movable(props) {
  const [disabled, setDisabled] = useState(props.disabled);
  const checkbox = !Helpers.Object.exists(props.checkbox) || props.checkbox;

  return (
    <div className={Helpers.String.join(['movable', props.className, (disabled ? 'disabled' : '')])}>
      <i className='icons8-braille' />
      {props.children}
      {!checkbox ? null :
        <Form.Check
          type='switch'
          id={Math.round(Math.random() * 10000)}
          label=''
          checked={!disabled}
          onChange={() => setDisabled(!disabled)}
          className='d-inline-block float-right'
        />
      }
    </div>
  );
}

function HierarchyTree(props) {
  const [expandAll, setExpandAll] = useState(false);
  const [collapseAll, setCollapseAll] = useState(false);

  let siteByNodeIdMap = {};

  for (const site of TestHierarchy) {
    siteByNodeIdMap[site.id] = { node: site, isSelected: false, childCountSelected: 0, children: [], isExpanded: (expandAll ? true : (collapseAll ? false : [211].includes(site.id))) };
  }
  for (const site of TestHierarchy) {
    if (siteByNodeIdMap[site.parentId]) {
      siteByNodeIdMap[site.parentId].children.push(site);
    }
  }

  const expand = () => {
    setExpandAll(true);
    setCollapseAll(false);
  };

  const collapse = () => {
    setCollapseAll(true);
    setExpandAll(false);
  };

  return (
    <>
      <div className='mb-2'>
        <a href='#' onClick={expand}>Expand All</a> | <a href='#' onClick={collapse}>Collapse All</a>
      </div>

      <SiteNode
        key={siteByNodeIdMap[211].node.id}
        node={siteByNodeIdMap[211].node}
        level={1}
        onChangeSelection={(id, newValue, parentsChain) => null}
        siteByNodeIdMap={siteByNodeIdMap}
        useFiltering={false}
        isReadOnly={props.isReadOnly}
        selectableFn={(node) => node.typeId === 5}
        variant='lh'
      />
    </>
  );
}

function HierarchyTreeModal(props) {
  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    props.onClose();
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='lh-outline' size='sm' onClick={handleClose} label='Cancel' />
        <Inputs.Button variant='lh' size='sm' onClick={handleSubmit} label='Apply' />
      </>
    );
  };

  return (
    <Popup
      title='Add Stores'
      footer={renderFooter()}
      show={props.show}
      onClose={handleClose}
      className='lighthouse-demo'
    >
      <HierarchyTree />
    </Popup>
  );
}


/*
<iframe src='http://localhost:3000/Developers/Demo/Lighthouse' style='border: none; width: 100%; height: 1715px;'></iframe>

document.getElementsByClassName('page-content')[0].innerHTML='<iframe src='http://localhost:3000/Developers/Demo/Lighthouse' style='border: none; width: 100%; height: 740px;'></iframe>';
*/
/*
document.getElementsByClassName('page-content')[0].innerHTML='<iframe src='https://manage.positouchcloud.com/Developers/Demo/Lighthouse' style='border: none; width: 100%; height: 740px;'></iframe>';
*/